import axios from "axios";
import appConfig from "configs/app.config";
import { REQUEST_HEADER_AUTH_KEY, TOKEN_TYPE } from "constants/api.constant";
import { PERSIST_STORE_NAME } from "constants/app.constant";
import deepParseJson from "utils/deepParseJson";
import { Environment, getEnvironment } from "utils/getEnvironment";

export const axiosQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async ({ baseUri, url, method, data, params, header = {} }, api, extraOptions) => {
    let headers = { ...header };
    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME);
    const persistData = deepParseJson(rawPersistData);

    // console.log("persistData", persistData)
    const accessToken = persistData.auth.session.token;
    // console.log("access", accessToken)

    // headers["ngrok-skip-browser-warning"] = "helli";
    // headers["Access-Control-Allow-Methods"] =
    //   "GET,PUT,POST,DELETE,PATCH,OPTIONS";
    if (accessToken) {
      headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`;
    }

    try {
      const result = await axios({
        url: baseUri ? baseUri : baseUrl + url,
        method,
        data,
        params,
        headers,
      });
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const baseQuery = axiosQuery({
  baseUrl: getEnvironment(Environment.DEVELOPMENT)
    ? appConfig.apiStaging
    : appConfig.apiPrefix,
});
